export default __webpack_public_path__ + "static/dt-desktop-9ca703549c9e1f0db18d5f3b464483b3.png";